export const menuType = {
    sideNav: 'sidenav',
    topNav: 'topNav'
}